export default __webpack_public_path__ + "static/media/logo.eade9f78.png";